"use strict";
var $ = require("../internals/export");
var DESCRIPTORS = require("../internals/descriptors");
var anObject = require("../internals/an-object");
var toPropertyKey = require("../internals/to-property-key");
var definePropertyModule = require("../internals/object-define-property");
var fails = require("../internals/fails");
var ERROR_INSTEAD_OF_FALSE = fails(function() {
  Reflect.defineProperty(definePropertyModule.f({}, 1, { value: 1 }), 1, { value: 2 });
});
$({ target: "Reflect", stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS }, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    var key = toPropertyKey(propertyKey);
    anObject(attributes);
    try {
      definePropertyModule.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});
